import styled from 'styled-components';

const Styled = styled.div`
    padding: 0.5em;
    font-size: 0.875rem;
    font-weight: 500;
    text-align: center;
    letter-spacing: 0.02em;
    cursor: pointer;

    &.hotfixes {
        color: white;
        background: #389e0d;
    }

    &.updates {
        color: white;
        background: #fa8c16;
    }
`;
export default Styled;
